import { Pipe, PipeTransform } from '@angular/core';
import { GridItem } from '../grid-control.model';
@Pipe({
  name: 'commandTitle'
})
export class CommandTitlePipe implements PipeTransform {
  transform(title: string | ((item?: any) => string), item: GridItem): string {
    if (!title) {
      return '';
    }
    if (typeof (title) === 'string') {
      return title;
    }
    return title(item);
  }
}
